import type { ReactNode } from 'react'
import { useAuth } from 'react-oidc-context'
import { NavLink } from 'react-router-dom'

export function Layout({ children }: { children: ReactNode }) {
  const auth = useAuth()
  return (
    <div className="layout">
      <header className="topbar">
        <strong>Hemägg CRM</strong>
        <nav className="nav">
          <NavLink to="/" end>Översikt</NavLink>
          <NavLink to="/customers">Kunder</NavLink>
          <NavLink to="/ring-list">Ringlista</NavLink>
          <NavLink to="/products">Produkter</NavLink>
          <NavLink to="/delivery-areas">Leveransområden</NavLink>
          <NavLink to="/delivery-list">Leveranslista</NavLink>
          <NavLink to="/invoices">Fakturor</NavLink>
          <NavLink to="/web-orders">Webborder</NavLink>
          <NavLink to="/sync-failures">Synk-fel</NavLink>
          <NavLink to="/settings">Inställningar</NavLink>
        </nav>
        <span className="spacer" />
        <span className="muted">{auth.user?.profile.email ?? auth.user?.profile.sub}</span>
        <button onClick={() => void auth.signoutRedirect()}>Logga ut</button>
      </header>
      <main className="content">{children}</main>
    </div>
  )
}
